import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../../component/Footer";
import Navbar from "../../component/Navbar";

import Arrow from "../../pages/Arrow";
import Generalsidebar from "../../pages/Generalsidebar";

const MainAudioPage = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  // console.log('userInfo', userInfo);
  function handleArrowClick() {
    setShowSidebar(true);
  }

  const audios = [
    {
      image:
        "https://res.cloudinary.com/djltdw88d/image/upload/v1700580258/thrive-audio-1-4/dpgiozcsvgnaufvz9cgw.png",
      title: "BLISSFUL SOUNDS",
      content:
        "Amidst the hustle and bustle of our daily lives, there exists a refuge of tranquility that can be found in the form of blissful sounds. These auditory treasures have the remarkable ability to transport us to realms of serenity, evoke emotions, and nurture our well-being.",
      link: "/audio1",
    },
    {
      image:
        "https://res.cloudinary.com/djltdw88d/image/upload/v1700580258/thrive-audio-1-4/y8pc2rzhfzohhieju9il.png",
      title: "SOOTHING STREAM SOUNDS",
      content:
        "Nature has a profound way of soothing our souls, and the ocean's tranquil sounds are among the most effective instruments in this symphony of tranquility. The rhythmic crashing of waves against the coastline carries with it a sense of constancy and predictability that lulls us into a state of relaxation.",
      link: "/audio2",
    },
    {
      image:
        "https://res.cloudinary.com/djltdw88d/image/upload/v1700580259/thrive-audio-1-4/nrtyh9vxmdyx2dfr8416.png",
      title: "SHAPING YOUR SAFESPOT",
      content:
        "Shaping this safe spot is a journey of self-care and intention, a pathway to cultivating emotional well-being and fostering resilience. Creating a safe spot is akin to crafting a mental refuge, a place within our consciousness where we can retreat when the world becomes overwhelming.",
      link: "/audio3",
    },
    {
      image:
        "https://res.cloudinary.com/djltdw88d/image/upload/v1700580270/thrive-audio-1-4/fy2rde6azzdwstlm0nkf.png",
      title: "PROBLEM SOLVING",
      content:
        "Problem solving is often driven by a desire to find solutions and overcome obstacles. It requires analytical thinking, resourcefulness, and determination. While this approach is essential for navigating the complexities of life, it sometimes focuses solely on external fixes, neglecting the internal landscapes where healing truly takes root.",
      link: "/audio4",
    },

    // Add more audios as needed
  ];

  const itemsPerPage = 3;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = audios
    .filter((audio) =>
      audio.title.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(
    audios.filter((audio) =>
      audio.title.toLowerCase().includes(searchTerm.toLowerCase())
    ).length / itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <div>
      <Navbar />
      <div onClick={handleArrowClick} className="absolute top-24 left-12 z-20">
        <Arrow />
      </div>
      <div className={showSidebar ? "show-sidebar" : "hidden"}>
        <Generalsidebar setShowSidebar={setShowSidebar} />
      </div>
      <div className="text-black ml-20 mt-2">
        <Link to="/mainresources">
          <button className="flex gap-1 px-4 py-2 rounded-xl w-fit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            Back
          </button>
        </Link>
      </div>
      <div className="mx-auto max-w-[900px] my-5 p-10 rounded-lg shadow-inner shadow-black">
        <div className="mx-10">
          <h1 className="text-3xl text-[#295700] font-serif font-bold py-5 text-center">
            OUR AUDIOS
          </h1>
          <div className="flex justify-center mb-4">
            <input
              type="text"
              placeholder="Search by title..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="border p-2 mr-2"
            />
            <button
              onClick={() => {
                setCurrentPage(1); // Reset page when search term changes
              }}
              className="bg-[#295700] text-white px-4 py-2 rounded  hover:bg-green-700"
            >
              Search
            </button>
          </div>
        </div>
        <div className="bg-[#DCAE96] px-4 py-4 text-center">
          {currentItems.map((video, index) => (
            <div key={index} className="mb-8">
              <img
                src={video.image}
                alt={`video ${index + 1}`}
                className="w-[50%] ml-[200px] mb-4 text-center"
              />
              <div>
                <h2 className="text-xl text-[#295700] font-serif font-bold mb-2">
                  {video.title}
                </h2>
                <p>{video.content}</p>
              </div>
              <div className="mt-4">
                <Link to={video.link}>
                  <button className="border-4 border-[#295700] px-5 py-1 rounded-2xl">
                    Listen to Audio
                  </button>
                </Link>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center m-8">
          {Array.from({ length: totalPages }, (_, index) => index + 1).map(
            (pageNumber) => (
              <button
                key={pageNumber}
                onClick={() => handlePageChange(pageNumber)}
                className="mx-2 px-3 py-1 border border-[#295700] rounded-full"
              >
                {pageNumber}
              </button>
            )
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MainAudioPage;
